module.exports = __webpack_public_path__ + "img/2.8468caa6.png";